
import { getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import { DatePicker } from 'v-calendar'
import { useStore } from 'vuex'
import * as Yup from 'yup'
import { Form, Field } from 'vee-validate'
import moment from 'moment'
import SelectFetchCustom from '@/views/components/form/SelectAsyncTest.vue'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import InputSwitch from 'primevue/inputswitch'
import Paginator from '@/views/components/paginator/Paginator.vue'

export default {
  components: {
    Dialog,
    Form,
    Field,
    InputText,
    DatePicker,
    SelectFetch,
    Button,
    SelectFetchCustom,
    DataTable,
    Column,
    ProgressSpinner,
    InputSwitch,
    Paginator
  },
  props: {
    partnerId: {
      default: () => null as any
    },
    contractId: {
      default: () => null as any
    },
    show: {
      type: Boolean,
      default: false
    },
  },
  emits: ['hideDialog', 'reloadData'],
  setup(props: any, { emit }: any) {
    const trayekDetailEndpoint = '/management/v1/TrayekDetail'
    const trayekRegularTypeId = '8e072a19-599c-45f0-a337-08dbd378cce6'
    const trayekAirportTypeId = '971ab31f-207d-4ad5-8670-d9fcb9185475'
    const { show, contractId, partnerId } = toRefs(props)
    const store = useStore()
    const app = getCurrentInstance()
    const {
      $toast,
      $icon
    } = app!.appContext.config.globalProperties
    const showModal = show.value
    const title = ref('Tambah')
    const isDetailOpen = ref(false)
    const dataSourceDetail = ref([]) as any
    const selectedPp = ref([]) as any
    const selectedTrayekType = ref(0)
    const selectedTrayekTypeId = ref(trayekRegularTypeId)
    const isTrayekOpen = ref(true)

    const filters = ref({
      search: '',
      filterField: ['code'],
      pageNumber: 1,
      pageSize: 10,
      totalRecords: 0,
      custom: [['trayekId', '=', '']] as any
    })

    const initialValues = reactive({
      StartDate: '',
      EndDate: '',
      Trayek: null,
      Passenger: null,
      IsActive: false
    })

    const schema = Yup.object().shape({
      StartDate: Yup.string().required('Tanggal Mulai tidak boleh kosong'),
      EndDate: Yup.string().required('Tanggal Berakhir tidak boleh kosong'),
      Trayek: Yup.object().required('Kelas tidak boleh kosong'),
      Passenger: Yup.object().required('Kelas tidak boleh kosong'),
    })

    const dataDummy = ref([
      { id: 0, nopol: 'xxx1', jam: '10:00', isSelected: 'false' },
      { id: 1, nopol: 'xxx2', jam: '11:00', isSelected: 'false' },
      { id: 2, nopol: 'xxx3', jam: '12:00', isSelected: 'false' },
      { id: 3, nopol: 'xxx4', jam: '13:00', isSelected: 'false' },
    ])

    const onSubmit = (values: any) => {
      console.log('values', values)
    }

    const closeDialog = () => {
      emit('hideDialog')
    }

    const getDetail = async (data: any) => {
      console.log('selectedData', data)
      store.dispatch('showLoading')
      dataSourceDetail.value = []
      filters.value.totalRecords = 0
      if (data) {
        filters.value.custom[0][2] = data.Id
        await apiUseCase.get(trayekDetailEndpoint, returnUrlPrams(filters.value)).then((response) => {
          const { error, result, count } = response
          if (!error) {
            filters.value.totalRecords = count
            dataSourceDetail.value = result.map((dataDetail: any) => ({
              ...dataDetail,
              IsSelected: false
            }))
          }
        })
        console.log('dataSourceDetail', dataSourceDetail.value)
      }
      store.dispatch('hideLoading')
    }

    const onChangePage = ({ page }: any) => {
      filters.value.pageNumber = page + 1
    }

    const onChangeTrayekType = (val: any, setFieldValue: any) => {
      if (val === 1) {
        selectedTrayekTypeId.value = trayekAirportTypeId
      } else {
        selectedTrayekTypeId.value = trayekRegularTypeId
      }
      if (val !== selectedTrayekType.value) {
        selectedTrayekType.value = val
        // isTrayekOpen.value = false
        setFieldValue('Trayek', null)
        dataSourceDetail.value = []
        isDetailOpen.value = false
        // isTrayekOpen.value = true
      }
    }

    onMounted(() => {
      console.log('partnerId', partnerId)
      if (contractId.value) {
        title.value = 'Edit'
      }
    })

    return {
      showModal,
      initialValues,
      schema,
      onSubmit,
      title,
      closeDialog,
      moment,
      dataDummy,
      getDetail,
      dataSourceDetail,
      selectedPp,
      isDetailOpen,
      selectedTrayekType,
      filters,
      onChangePage,
      selectedTrayekTypeId,
      onChangeTrayekType,
      isTrayekOpen,
      contractId
    }
  }
}

